import React from "react";
var __jsx = React.createElement;
import { useEffect, useRef } from "react";
import Markdown from "markdown-to-jsx";
import Layout from "@/_LayoutsRelated/layout/Layout";
import { useCart } from "@/common/Contexts/CartContext";
import OilCartItems from "./components/OilCartItems/OilCartItems";
import OilCartSummary from "./components/OilCartSummary/OilCartSummary";
import OilCartEmpty from "./components/OilCartEmpty/OilCartEmpty";
import MobilePageHeader from "./components/MobilePageHeader/MobilePageHeader";
import { AuthPopupHOC, useSession } from "@/_MiniApps/auth/AuthContext";
import { useLang } from "@/common/Contexts/LanguageContext";
import { useCMS } from "@hooks/useCMS";
import { useTranslation } from "@i18n";
import banners from "@data/banners/login-pages/signup.json";
import useHelpers from "@hooks/useHelpers";
import { Icon } from "@syarahtech/ui";
import { trackEvents } from "@/common/events/events";
var Skel = function Skel(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className;
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-[#E9EEF5] rounded-lg animate-pulse ".concat(className)
  });
};
var CartItemRowSkeleton = function CartItemRowSkeleton(_ref2) {
  var classNames = _ref2.classNames;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(classNames, "\n     flex items-center gap-3 px-4 py-4 border-b border-[#F0F2F5] last:border-b-0\n")
  }, /*#__PURE__*/React.createElement(Skel, {
    className: "w-[80px] h-[80px] rounded-xl flex-shrink-0"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 flex flex-col gap-2"
  }, /*#__PURE__*/React.createElement(Skel, {
    className: "h-3 w-1/3"
  }), /*#__PURE__*/React.createElement(Skel, {
    className: "h-4 w-2/3"
  }), /*#__PURE__*/React.createElement(Skel, {
    className: "h-3 w-1/4"
  })), /*#__PURE__*/React.createElement(Skel, {
    className: "w-[80px] h-8 rounded-lg flex-shrink-0"
  }));
};
var CartItemsSkeleton = function CartItemsSkeleton() {
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-white md:rounded-2xl border border-[#E9EEF5] shadow-sm overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between px-4 py-4 border-b border-[#F0F2F5]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-end gap-1.5"
  }, /*#__PURE__*/React.createElement(Skel, {
    className: "h-4 w-28"
  }), /*#__PURE__*/React.createElement(Skel, {
    className: "h-3 w-20"
  })), /*#__PURE__*/React.createElement(Skel, {
    className: "h-4 w-16"
  })), /*#__PURE__*/React.createElement(CartItemRowSkeleton, null), /*#__PURE__*/React.createElement(CartItemRowSkeleton, null), /*#__PURE__*/React.createElement(CartItemRowSkeleton, null), /*#__PURE__*/React.createElement(CartItemRowSkeleton, {
    classNames: "md:flex hidden"
  }));
};
var CartSummarySkeleton = function CartSummarySkeleton() {
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-white md:rounded-2xl border border-[#E9EEF5] shadow-sm px-4 py-4"
  }, /*#__PURE__*/React.createElement(Skel, {
    className: "h-4 w-28 mb-4"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-3"
  }, [0, 1, 2].map(function (i) {
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: "flex items-center justify-between py-1"
    }, /*#__PURE__*/React.createElement(Skel, {
      className: "h-3 w-20"
    }), /*#__PURE__*/React.createElement(Skel, {
      className: "h-3 w-16"
    }));
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between pt-2 border-t border-[#F0F2F5]"
  }, /*#__PURE__*/React.createElement(Skel, {
    className: "h-4 w-16"
  }), /*#__PURE__*/React.createElement(Skel, {
    className: "h-4 w-24"
  }))), /*#__PURE__*/React.createElement(Skel, {
    className: "hidden md:block mt-4 h-12 w-full rounded-xl"
  }));
};
var OilCartPage = function OilCartPage() {
  var _itemsBlock$content, _itemsBlock$content2;
  var _useCart = useCart(),
    cartData = _useCart.cartData,
    cartId = _useCart.cartId,
    loadCart = _useCart.loadCart,
    isLoading = _useCart.isLoading,
    items = _useCart.items,
    totalItems = _useCart.totalItems,
    totalFinalPrice = _useCart.totalFinalPrice;
  var _useHelpers = useHelpers(),
    navigateToHard = _useHelpers.navigateToHard;
  var lang = useLang();
  var _useCMS = useCMS(),
    imageUrl = _useCMS.imageUrl;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn;
  var cartViewedFired = useRef(false);
  useEffect(function () {
    loadCart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(function () {
    if (cartData !== null && !cartViewedFired.current) {
      cartViewedFired.current = true;
      var referral = __IS_CSR__ ? function () {
        var ref = document.referrer;
        if (ref.includes("/products/oil/")) return "oil_details";
        if (ref === "" || ref === "/" || ref.match(/\/(ar|en)?\/?$/)) return "home_page";
        return "oil_listing";
      }() : "oil_listing";
      trackEvents("vas_cart_viewed", {
        products_count: items.length,
        total_quantity: totalItems,
        total_amount: totalFinalPrice,
        referral_location: referral
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartData]);
  var authScreenDesign = {
    banners: {
      desktop: imageUrl(banners[lang].desktop_images[0]),
      mobile: imageUrl(banners[lang].mobile_images[0])
    },
    title: t("sign_register"),
    description: t("sign_register_access_account")
  };
  var busy = isLoading;
  var handleCheckout = function handleCheckout(_userData, _isPendingActionCall) {
    if (!cartId) return;
    navigateToHard("/site/cart/checkout?cart_id=".concat(encodeURIComponent(cartId)));
  };
  var onCheckoutClick = function onCheckoutClick(checkAuth) {
    if (busy) return;
    var summary = {
      products_count: items.length,
      total_quantity: totalItems,
      total_amount: totalFinalPrice
    };
    if (__IS_CSR__) {
      localStorage.setItem("oil_cart_payment_summary", JSON.stringify(summary));
    }
    trackEvents("vas_checkout_started", summary);
    if (!isLoggedIn) {
      trackEvents("vas_checkout_login_required", {});
    }
    checkAuth(handleCheckout);
  };

  // Full-page skeleton only on initial fetch. Quantity updates keep cartData
  // and show skeletons on summary price values only (see OilCartSummary).
  if (cartData === null) {
    return /*#__PURE__*/React.createElement(Layout, {
      headHideLinks: true,
      disableLoader: true,
      hideOrangeHeadBtn: true,
      showUserAvatar: true,
      hideHeaderOnmobile: true,
      custommobileHeader: /*#__PURE__*/React.createElement(MobilePageHeader, {
        backUrl: "/products/oil"
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-[#F0F2F5] min-h-screen pb-24 md:pb-10",
      dir: "rtl"
    }, /*#__PURE__*/React.createElement("div", {
      className: "hidden md:flex flex-row gap-6 max-w-[1200px] mx-auto px-6 pt-8"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex-[0_0_58%]"
    }, /*#__PURE__*/React.createElement(CartItemsSkeleton, null)), /*#__PURE__*/React.createElement("div", {
      className: "flex-1"
    }, /*#__PURE__*/React.createElement(CartSummarySkeleton, null))), /*#__PURE__*/React.createElement("div", {
      className: "md:hidden flex flex-col gap-4 px-0 pt-4 pb-8"
    }, /*#__PURE__*/React.createElement(CartItemsSkeleton, null), /*#__PURE__*/React.createElement(CartSummarySkeleton, null)), /*#__PURE__*/React.createElement("div", {
      className: "md:hidden fixed bottom-0 inset-x-0 bg-white px-5 pt-5 pb-8"
    }, /*#__PURE__*/React.createElement(Skel, {
      className: "h-12 w-full rounded-lg"
    }))));
  }

  // Determine if cart has items
  var itemsBlock = cartData.find(function (b) {
    return b.component_type === "cart_items";
  });
  var hasItems = ((_itemsBlock$content = itemsBlock === null || itemsBlock === void 0 ? void 0 : itemsBlock.content) !== null && _itemsBlock$content !== void 0 ? _itemsBlock$content : []).some(function (b) {
    return b.component_type === "cart_item_oil";
  });

  // CTA block for mobile sticky bar
  var ctaBlock = cartData.find(function (b) {
    return b.component_type === "cart_cta";
  });
  // All cart_item_oil blocks (for count display in badge)
  var oilItems = ((_itemsBlock$content2 = itemsBlock === null || itemsBlock === void 0 ? void 0 : itemsBlock.content) !== null && _itemsBlock$content2 !== void 0 ? _itemsBlock$content2 : []).filter(function (b) {
    return b.component_type === "cart_item_oil";
  });
  var totalCount = oilItems.reduce(function (sum, b) {
    return sum + b.content.count;
  }, 0);
  if (!hasItems) {
    return /*#__PURE__*/React.createElement(Layout, {
      headHideLinks: true,
      disableLoader: true,
      hideOrangeHeadBtn: true,
      showUserAvatar: true,
      showCartIcon: true,
      hideHeaderOnmobile: true,
      custommobileHeader: /*#__PURE__*/React.createElement(MobilePageHeader, {
        backUrl: "/products/oil"
      })
    }, /*#__PURE__*/React.createElement(OilCartEmpty, null));
  }
  return /*#__PURE__*/React.createElement(Layout, {
    headHideLinks: true,
    disableLoader: true,
    hideOrangeHeadBtn: true,
    showUserAvatar: true,
    showCartIcon: true,
    hideHeaderOnmobile: true,
    custommobileHeader: /*#__PURE__*/React.createElement(MobilePageHeader, {
      backUrl: "/products/oil"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-[#F0F2F5] md:!min-h-[800px] pb-24 md:pb-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden md:flex flex-row gap-6 max-w-[1200px] mx-auto px-6 pt-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-[0_0_58%]"
  }, /*#__PURE__*/React.createElement(OilCartItems, null)), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 sticky top-4 self-start"
  }, /*#__PURE__*/React.createElement(OilCartSummary, {
    variant: "desktop"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "md:hidden flex flex-col gap-4 px-0 pt-4 pb-8"
  }, /*#__PURE__*/React.createElement(OilCartItems, null), /*#__PURE__*/React.createElement(OilCartSummary, {
    variant: "mobile"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "md:hidden rounder-2xl fixed bottom-0 inset-x-0 z-[9999] bg-white px-5 pt-5 pb-8"
  }, /*#__PURE__*/React.createElement(AuthPopupHOC, {
    authScreenDesign: authScreenDesign,
    customModalClassName: "modalHideHeader",
    renderFunc: function renderFunc(checkAuth) {
      var _ctaBlock$content$pri;
      return /*#__PURE__*/React.createElement("button", {
        onClick: function onClick() {
          return onCheckoutClick(checkAuth);
        },
        disabled: busy,
        className: "flex items-center justify-between px-4 py-3.5 w-full bg-[#0D0DB5] rounded-lg border-0 cursor-pointer disabled:opacity-70"
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex items-center gap-2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "relative flex items-center justify-center w-10 no-underline",
        "aria-label": "cart"
      }, /*#__PURE__*/React.createElement(Icon, {
        icon: "material-symbols--shopping-cart-outline-rounded",
        className: "text-white",
        width: 6,
        height: 6
      }), totalCount > 0 && /*#__PURE__*/React.createElement("span", {
        className: "absolute -top-0.5 -start-0.5 min-w-[17px] h-[17px] px-[3px] flex items-center justify-center rounded-full bg-[#EC6234] text-white text-[9px] font-bold leading-none"
      }, totalCount)), /*#__PURE__*/React.createElement("span", {
        className: "text-white font-bold text-[15px]"
      }, ctaBlock === null || ctaBlock === void 0 ? void 0 : ctaBlock.content.cta_label)), busy ? /*#__PURE__*/React.createElement(Skel, {
        className: "h-4 w-20 !bg-white/40"
      }) : /*#__PURE__*/React.createElement(Markdown, {
        className: "text-white font-bold text-[15px]"
      }, (_ctaBlock$content$pri = ctaBlock === null || ctaBlock === void 0 ? void 0 : ctaBlock.content.price.current_formatted) !== null && _ctaBlock$content$pri !== void 0 ? _ctaBlock$content$pri : ""));
    }
  })));
};
export default OilCartPage;